import { render, staticRenderFns } from "./ComponentForm.vue?vue&type=template&id=69f77666"
import script from "./ComponentForm.vue?vue&type=script&lang=ts"
export * from "./ComponentForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports